'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'gem';
var width = 512;
var height = 512;
var aliases = [128142];
var unicode = 'f3a5';
var svgPathData = ['M48.1 192L222.7 192 125.5 70.4 48.1 192zM59 224L256 433.3 453 224 59 224zM161.3 64L256 182.4 350.7 64 161.3 64zm128 128l174.6 0-77.4-121.6-97.2 121.6z', 'M278 456.7L256 480 234 456.7 0 208 112 32 400 32 512 208 278 456.7zM453 224L59 224 256 433.3 453 224zm10.9-32L386.5 70.4 289.3 192 463.9 192zM350.7 64L161.3 64 256 182.4 350.7 64zM125.5 70.4L48.1 192 222.7 192 125.5 70.4z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faGem = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;